import { FileDesc } from '@wellesley/openapi'

type VideoCheckerProps = {
  file: FileDesc
  allowedExtensions?: string[]
}

const VIDEO_MIME_BY_EXT: Record<string, string> = {
  mp4: 'video/mp4',
  webm: 'video/webm',
  ogg: 'video/ogg',
  mov: 'video/quicktime',
  m3u8: 'application/vnd.apple.mpegurl', // HLS
  mpd: 'application/dash+xml', // DASH
}

let probeEl: HTMLVideoElement | null = null
const getProbe = () => (probeEl ??= document.createElement('video'))

export const canPlayMime = (mime: string): boolean => {
  if (!mime) return false
  if (typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported) {
    try {
      if (MediaSource.isTypeSupported(mime)) return true
    } catch {
      return false
    }
  }
  const res = getProbe().canPlayType(mime)
  return res === 'probably' || res === 'maybe'
}

export const canPlayVideoBlob = (file: File): boolean => {
  return !!file.type && canPlayMime(file.type)
}

export const isPlayableVideo = ({
  file,
  allowedExtensions,
}: VideoCheckerProps): boolean => {
  const ext = file.extension.toLowerCase()

  if (ext === 'm3u8') return true

  if (allowedExtensions && !allowedExtensions.includes(ext)) return false

  const mime = VIDEO_MIME_BY_EXT[ext] || ''
  return canPlayMime(mime)
}
